'use client';

import { SparklesIcon } from '@heroicons/react/24/solid';
import Tooltip from '@/components/common/Tooltip';

interface AssistantFabProps {
  onClick: () => void;
  badge?: boolean;
  pendingCount?: number;
  pendingLabel?: string;
}

export default function AssistantFab({ onClick, badge, pendingCount = 0, pendingLabel }: AssistantFabProps) {
  const button = (
    <button
      onClick={onClick}
      className="bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 group relative"
      aria-label="Open Content Strategist"
    >
      <SparklesIcon className="h-8 w-8" />
      {badge && (
        <span className="absolute top-0 right-0 h-3 w-3 bg-red-500 rounded-full border-2 border-white"></span>
      )}
    </button>
  );

  // Determine tooltip content
  let tooltipContent = null;
  if (badge) {
    if (pendingCount === 1 && pendingLabel) {
      tooltipContent = pendingLabel;
    } else if (pendingCount > 1) {
      tooltipContent = `You have ${pendingCount} pending tasks`;
    } else {
      tooltipContent = "You have a pending request";
    }
  }

  return (
    <div className="fixed bottom-8 right-8 z-50 hidden md:block">
      {tooltipContent ? (
        <Tooltip
          content={tooltipContent}
          className="!w-auto block whitespace-nowrap"
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
    </div>
  );
}
